const getEnvironment = () => process.env.REACT_APP_ENV;

// Azure Blob SAS URLs
export const AZURE_BLOB_SAS_STAGING_URL = `${process.env.REACT_APP_AZURE_BLOB_SAS_STAGING_URL}`;
export const AZURE_BLOB_SAS_PRODUCTION_URL = `${process.env.REACT_APP_AZURE_BLOB_SAS_PRODUCTION_URL}`;

export const AZURE_STAGING_URL = `${process.env.REACT_APP_AZURE_STAGING_URL}`;
export const AZURE_PRODUCTION_URL = `${process.env.REACT_APP_AZURE_PRODUCTION_URL}`;

// Containers in Azure Blob Storage
export const AZURE_BLOB_CONTAINER_CERTIFICATES = "certificates";

export const AZURE_BLOB_SAS_URL = getEnvironment() === "production" 
  ? AZURE_BLOB_SAS_PRODUCTION_URL 
  : getEnvironment() === "staging" 
    ? AZURE_BLOB_SAS_STAGING_URL 
    : null;

export const AZURE_URL = getEnvironment() === "production" 
  ? AZURE_PRODUCTION_URL 
  : getEnvironment() === "staging" 
    ? AZURE_STAGING_URL 
    : null;